export default __webpack_public_path__ + "static/media/t23.4d3406ff.jpg";